import _ from "lodash";

import {
    IFieldsState,
    AddFieldWithTempIdActionType,
    FieldsActionTypes,
    IField,
    DuplicateFieldWithTempIdActionType,
    InitFieldsActionType,
    AddFieldRequestActionType,
    AddFieldSuccessActionType,
    AddFieldFailureActionType,
    DuplicateFieldSuccessActionType,
    DuplicateFieldFailureActionType,
    DuplicateFieldRequestActionType,
    DeleteFieldRequestActionType,
    DeleteFieldSuccessActionType,
    DeleteFieldFailureActionType,
    ChangeIsFomHavePaymentTypeFieldActionType,
    ChangeIsFomHavePromoCodeFieldActionType,
    FieldTypes,
} from "./types";
import { fieldInitials } from "./initails";
import { Handler } from "../types/store-types";
import { getDeclarableField, getDeclarableValues, getFieldByType } from "./../../helpers/fieldActions";

const initFields: Handler<IFieldsState, InitFieldsActionType> = (state, { payload: { list } }) => {
    let isHavePaymentTypeField = false;
    let isHavePromoCodeField = false;

    const newList = list.map(item => {
        const fieldAdditionals = getFieldByType(item.type);
        setTimeout(() => {
            const data = getDeclarableField(item.type, item._id, true, item);
            //@ts-ignore
            window.declareFields(data);
        });
        if (item.type === FieldTypes.PROMOCODE) {
            isHavePromoCodeField = true;
        } else if (item.type === FieldTypes.PAYMENT_METHOD) {
            isHavePaymentTypeField = true;
        }
        return {
            type: item.type,
            _id: item._id,
            group: fieldAdditionals && (fieldAdditionals.group as IField["group"]),
            name: fieldAdditionals && (fieldAdditionals.name as IField["name"]),
            elements: fieldAdditionals && (fieldAdditionals.elements as IField["elements"]),
            label: item.label ? item.label : "",
        };
    });
    return { ...state, list: newList, isHavePaymentTypeField, isHavePromoCodeField };
};

/* -- Add Field Handlers -- */

const addFieldWithTempId: Handler<IFieldsState, AddFieldWithTempIdActionType> = (
    state,
    { payload: { type, id, data } },
) => {
    const newField = { ...(fieldInitials.find(initial => initial.type === type) as IField) };
    const { list } = state;

    //@ts-ignore
    window.declareFields(getDeclarableField(type, id, false, data));

    newField._id = id;

    return { ...state, list: [...list, newField] };
};

const addFieldRequest: Handler<IFieldsState, AddFieldRequestActionType> = state => {
    return { ...state, isLoading: true };
};

const addFieldSuccess: Handler<IFieldsState, AddFieldSuccessActionType> = (state, { payload: { fieldId, tempId } }) => {
    const { list } = _.cloneDeep(state);

    list.forEach(value => {
        if (value._id === tempId) {
            value._id = fieldId;
            value.tempId = tempId;
        }
    });

    return { ...state, list: [...list], isLoading: false };
};

const addFieldFailure: Handler<IFieldsState, AddFieldFailureActionType> = state => {
    return { ...state, isLoading: false };
};

/* -- Delete Fields Handler */

const deleteFieldRequest: Handler<IFieldsState, DeleteFieldRequestActionType> = (
    state,
    { payload: { fieldId: deletingFieldId } },
) => {
    const list = _.cloneDeep(state.list).filter(field => field._id !== deletingFieldId);

    return { ...state, list };
};

const deleteFieldSuccess: Handler<IFieldsState, DeleteFieldSuccessActionType> = state => {
    return { ...state };
};

const deleteFieldFailure: Handler<IFieldsState, DeleteFieldFailureActionType> = state => {
    return { ...state };
};

/* -- Duplicate Field Handler */
const dublicateFieldWithTempId: Handler<IFieldsState, DuplicateFieldWithTempIdActionType> = (
    state,
    { payload: { fieldId, tempId, index } },
) => {
    let list = _.cloneDeep(state.list);
    const fieldsListFirstPart = _.slice(list, 0, index + 1);
    const fieldsListSecondPart = _.slice(list, index + 1);
    const duplicatedField = _.cloneDeep(list.find(field => field._id === fieldId)) as IField;

    if (duplicatedField && duplicatedField._id) {
        const oldField = _.cloneDeep(window.__current_form_state.values.fields[fieldId]);
        duplicatedField._id = tempId;
        if (oldField?.value?.enabled || oldField?.paymentOptions?.enabled) {
            if (oldField?.paymentOptions?.enabled) {
                oldField.paymentOptions.enabled = false;
            } else {
                oldField.value.enabled = false;
            }
        }

        //@ts-ignore
        window.declareFields(getDeclarableValues(oldField, tempId));
        list = _.concat(fieldsListFirstPart, duplicatedField, fieldsListSecondPart);
    }

    return { ...state, list };
};

const duplicateFieldRequest: Handler<IFieldsState, DuplicateFieldRequestActionType> = state => {
    return { ...state };
};

const duplicateFieldSuccess: Handler<IFieldsState, DuplicateFieldSuccessActionType> = (
    state,
    { payload: { fieldId, tempId } },
) => {
    const { list } = state;

    list.forEach(value => {
        if (value._id === tempId) {
            value._id = fieldId;
            value.tempId = tempId;
        }
    });

    return { ...state, list: [...list], isLoading: false };
};

const duplicateFieldFailure: Handler<IFieldsState, DuplicateFieldFailureActionType> = state => {
    return { ...state, isLoading: false };
};

const changeIsFormHavePromoCodeField: Handler<IFieldsState, ChangeIsFomHavePromoCodeFieldActionType> = (
    state,
    { payload },
) => {
    return { ...state, isHavePromoCodeField: payload.value };
};
const changeIsFormHavePaymentTypeField: Handler<IFieldsState, ChangeIsFomHavePaymentTypeFieldActionType> = (
    state,
    { payload },
) => {
    return { ...state, isHavePaymentTypeField: payload.value };
};

export const handlersFields = {
    [FieldsActionTypes.INIT_FIELDS]: initFields,

    [FieldsActionTypes.ADD_WITH_TEMP_ID]: addFieldWithTempId,
    [FieldsActionTypes.ADD_FIELD_REQUEST]: addFieldRequest,
    [FieldsActionTypes.ADD_FIELD_SUCCESS]: addFieldSuccess,
    [FieldsActionTypes.ADD_FIELD_FAILURE]: addFieldFailure,

    [FieldsActionTypes.DELETE_FIELD_REQUEST]: deleteFieldRequest,
    [FieldsActionTypes.DELETE_FIELD_SUCCESS]: deleteFieldSuccess,
    [FieldsActionTypes.DELETE_FIELD_FAILURE]: deleteFieldFailure,

    [FieldsActionTypes.DUPLICATE_FIELD_WITH_TEMP_ID]: dublicateFieldWithTempId,
    [FieldsActionTypes.DUPLICATE_FIELD_REQUEST]: duplicateFieldRequest,
    [FieldsActionTypes.DUPLICATE_FIELD_SUCCESS]: duplicateFieldSuccess,
    [FieldsActionTypes.DUPLICATE_FIELD_FAILURE]: duplicateFieldFailure,

    [FieldsActionTypes.CHANGE_IS_FORM_HAVE_PAYMENT_TYPE_FIELD]: changeIsFormHavePaymentTypeField,
    [FieldsActionTypes.CHANGE_IS_FORM_HAVE_PROMOCODE_FIELD]: changeIsFormHavePromoCodeField,
};
